/**
 * Builds a user-facing alert for PUT /production-items/:id/quantity when the API returns 400
 * with quantity_sum_exceeds_max (structured fields and/or error_code).
 */
export function getProductionQuantitySaveErrorAlert(
  error: unknown,
  t: (key: string, params?: Record<string, string | number>) => string
): string | null {
  const err = error as { response?: { status?: number; data?: Record<string, unknown> } };
  const status = err.response?.status;
  const data = err.response?.data;
  if (status !== 400 || !data || typeof data !== 'object') {
    return null;
  }

  const code = data.error_code ?? data.message;
  const isSumExceeds =
    code === 'quantity_sum_exceeds_max' ||
    (data.max_quantity != null &&
      data.attempted_add != null &&
      data.would_be_total != null);

  if (!isSumExceeds) {
    return null;
  }

  if (
    data.max_quantity != null &&
    data.attempted_add != null &&
    data.would_be_total != null
  ) {
    return `${t('common.error')}: ${t('myProduction.errorQuantitySumExceedsMax', {
      max: data.max_quantity as number,
      current: (data.current_value ?? 0) as number,
      attempted: data.attempted_add as number,
      total: data.would_be_total as number,
    })}`;
  }

  return `${t('common.error')}: ${t('myProduction.errorQuantitySumExceedsMaxGeneric')}`;
}
